import React from 'react';
import { cn } from './utils/cn';

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function GooRangeSlider({
  min = 0,
  max = 100,
  step = 1,
  value,
  onChange,
  fill = 'rgba(34,197,94,0.7)',
  className,
  trackClassName,
  thumbClassName,
  dense = false,
  showValue = true,
  formatValue,
  ariaLabel = 'Range slider',
}) {
  const lo = Number(min);
  const hi = Number(max);
  if (!Number.isFinite(lo) || !Number.isFinite(hi) || hi <= lo) return null;

  const normalizedStep = Number.isFinite(Number(step)) && Number(step) > 0 ? Number(step) : 1;
  const raw = Number(value);
  const current = clamp(Number.isFinite(raw) ? raw : lo, lo, hi);
  const progress = ((current - lo) / (hi - lo)) * 100;

  return (
    <div className={cn('w-full', className)}>
      {showValue ? (
        <div className="mb-2 flex items-center justify-between text-xs text-slate-300">
          <span>{lo}</span>
          <span className="font-semibold text-white">
            {typeof formatValue === 'function' ? formatValue(current) : current}
          </span>
          <span>{hi}</span>
        </div>
      ) : null}
      <div
        className={cn(
          'relative rounded-full border border-white/15 bg-black/25 px-2',
          dense ? 'py-1.5' : 'py-2.5',
          trackClassName
        )}
      >
        <div className={cn('pointer-events-none h-1.5 rounded-full bg-white/15', dense && 'h-1')}>
          <div
            className="h-full rounded-full transition-[width] duration-100"
            style={{ width: `${progress}%`, background: fill }}
          />
        </div>
        <input
          type="range"
          min={lo}
          max={hi}
          step={normalizedStep}
          value={current}
          onChange={(e) => onChange?.(Number(e.target.value))}
          aria-label={ariaLabel}
          className={cn(
            'absolute inset-0 h-full w-full cursor-pointer appearance-none bg-transparent opacity-0',
            thumbClassName
          )}
        />
      </div>
    </div>
  );
}

